import React from 'react';
import styled from 'styled-components';
import { Inline } from '@99designs/emu';
import { minHeights } from '@99designs/emu/settings';
import Label from './Label';

interface RadioProps extends React.InputHTMLAttributes<HTMLInputElement> {
    children: React.ReactNode;
}

const RadioInput = styled.input`
    && {
        width: ${minHeights.inputControl}px;
        height: ${minHeights.inputControl}px;
    }
`;

const Radio = React.forwardRef(function Radio(
    { children, id, name, value, ...rest }: RadioProps,
    ref: React.RefObject<HTMLInputElement>
) {
    return (
        <Inline space="1bu">
            <RadioInput ref={ref} type="radio" id={id} name={name} value={value} {...rest} />
            <Label htmlFor={id}>{children}</Label>
        </Inline>
    );
});

export default Radio;
